import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { fetchFsGamesData, fetchFsPolasData } from '../../store/actions/fsGameAction';
import Loading from '../Loading';

const FastSpinCard = (data) => {
  const dispatch = useDispatch();
  const { fsNames, fsImages, fsPolas, nameAndImagesIsLoading } = useSelector((state) => state.fsGameReducer);
  
  useEffect(() => {
    dispatch(fetchFsPolasData());
    dispatch(fetchFsGamesData());
  }, [dispatch]);

  if (data.isLoading || nameAndImagesIsLoading) return (
    <>
      <Loading />
    </>
  )

  return (
    <>
      <h2>Fast Spin</h2>
      <section className="container px-3 sm:px-12 mx-auto" id="fs">
        <div className='grid grid-cols-2 lg:grid-cols-6 gap-4 justify-items-center'>
          {
            fsNames.map((fsName, i) => {
              return (
                <div key={i} className="w-full grid justify-items-center bg-item p-3">
                  <div className="relative flex-shrink-0">
                    <img width={"150px"} src={fsImages[i]} alt={fsName} />
                  </div>
                  <div className="grid box-content text-center content-center capitalize mb-3">
                    <span className="game-name h-12 grid content-center">{fsName}</span>
                    <div className="jam px-5 py-3 mb-3">
                      <span>Jam Gacor: </span>
                      <span className="jamGacor">
                        {data.jamGacors[i] ? data.jamGacors[i].value10 : ''}
                      </span>
                    </div>
                    <span>Pola: </span>
                    <span className="v">{fsPolas[i] ? `${fsPolas[i].value1} - ${fsPolas[i].value2} - ${fsPolas[i].value3}` : ''}</span>
                  </div>
                  <div className='single-bar relative items-center'>
                    <div className='absolute font-bold rtpValue' style={{ top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
                      <span>{data.rtps[i] ? data.rtps[i].value10 : ''}%</span>
                    </div>
                    <div className="single-bar__fill bar animated-gradient" style={{ width: `${data.rtps[i] ? data.rtps[i].value10 : ''}%` }}></div>
                  </div>
                </div>
              );
            })
          }
        </div>
      </section >
    </>
  );
};

export default FastSpinCard;